import type { OnInit, Type } from '@angular/core';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import type { Observable } from 'rxjs';
import { EMPTY, of, switchMap } from 'rxjs';
import { ModalDialogComponent } from './modal-dialog.component';

export interface DialogParams<TInputEntity> {
  input?: TInputEntity;
  config: DialogConfig;
}

export interface ButtonParams {
  label: string;
  icon?: string;
  isDanger?: boolean;
}

export interface DialogConfig {
  title: string;
  description?: string;

  width?: string;
  height?: string;
  maxWidth?: string;
  minWidth?: string;
  maxHeight?: string;
  minHeight?: string;

  disableClose?: boolean;

  showSaveButton?: boolean;
  showCancelButton?: boolean;

  saveButton?: ButtonParams;
  cancelButton?: ButtonParams;

  position?: {
    left: string;
    top: string;
  };
}

export interface IDialogContentComponent<TResult, TInput> extends OnInit {
  input?: TInput;
  getResult(): TResult;
  isDisabled(): boolean;
}

export interface DialogData<TResult, TInputEntity> {
  dialogContentComponent: Type<IDialogContentComponent<TResult, TInputEntity>>;
  params: DialogParams<TInputEntity>;
}

@Injectable()
export class ModalDialogService<TResult, TInputEntity> {
  constructor(private readonly dialog: MatDialog) {}

  openDialog(
    params: DialogParams<TInputEntity>,
    dialogContentComponent: Type<IDialogContentComponent<TResult, TInputEntity>>,
    lateralDialog?: boolean
  ): Observable<TResult> {
    // const dialogRef = this.dialog.open<ModalDialogComponent<TResult, TInputEntity>, DialogData<TResult, TInputEntity>>(ModalDialogComponent, {
    //   height: params.config.height ? params.config.height : undefined,
    //   width: params.config.width ? params.config.width : undefined,
    //   maxWidth: params.config.maxWidth,
    //   minWidth: params.config.minWidth,
    //   maxHeight: params.config.maxHeight,
    //   minHeight: params.config.minHeight,
    //   disableClose: params.config.disableClose !== false,
    //   data: {
    //     dialogContentComponent,
    //     params
    //   }
    // });

    const dialogConfig: any = {
      height: params.config.height ? params.config.height : undefined,
      width: params.config.width ? params.config.width : undefined,
      maxWidth: params.config.maxWidth,
      minWidth: params.config.minWidth,
      maxHeight: params.config.maxHeight,
      minHeight: params.config.minHeight,
      disableClose: params.config.disableClose !== false,
      data: {
        dialogContentComponent,
        params
      }
    };

    if (lateralDialog && lateralDialog) {
      dialogConfig.position = {
        left: '10px',
        bottom: '10px'
      };
    }

    const dialogRef = this.dialog.open<ModalDialogComponent<TResult, TInputEntity>, DialogData<TResult, TInputEntity>>(ModalDialogComponent, dialogConfig);

    return dialogRef.afterClosed().pipe(
      switchMap((o: TResult) => {
        if (o != null) {
          return of(o );
        } else {
          return EMPTY;
        }
      }),
    );
  }
}
